import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// ANT DESIGN
import { Row, Typography, Col, Collapse, Button, Divider, Spin } from "antd";
import { EditOutlined, PlusCircleOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import { apiConfig, labelConfig } from "../../../../customer.config";
import cnt from "../../../../../../services/definedConstant";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";

const { Text, Title } = Typography;
const { Panel } = Collapse;

function AddressInfoTab(props) {
  const {
    currentCustomerObj,
    customerDetails,
    addressDetails,
    userData,
    refreshList,
  } = props;
  const { session } = userData;

  const navigate = useNavigate();
  // console.log(customerDetails);
  // const [selectedRow, setSelectedRow] = useState(null);
  const [isCardCollapsed, setIsCardCollapsed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    console.log(addressDetails);
    console.log(currentCustomerObj);
  }, []);

  const handleCardCollapse = () => {
    setIsCardCollapsed(!isCardCollapsed);
  };

  const handleAddressAdd = () => {
    // navigate("/new-address", { replace: false });
    navigate("/new-address", { state: currentCustomerObj });
  };

  function handleAddressEdit(param) {
    // navigate("/edit-address", { replace: false });
    console.log(param);
    // return;
    navigate("/edit-address", {
      state: {
        ...currentCustomerObj,
        addressTypeId: param.addressTypeId,
        addressId: param.addressId,
      },
    });
  }

  const handleDisableOrEnable = async (param) => {
    let payload = {};
    payload.isActive = param?.isActive === true ? "false" : "true";
    payload.addressId = param?.addressId;

    const url = `${apiConfig.Client}/${currentCustomerObj.id}/addresses`;

    const body = {
      ...payload,
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          console.log(err);
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(
            cnt.SUCCESS,
            param?.isActive === true
              ? labelConfig.disableSuccessMsg
              : labelConfig.enableSuccessMsg
          );

          // Refresh Data
          refreshList();

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <>
      {BOM.HasPermission("CREATE_ADDRESS") && (
        <Button
          type="primary"
          shape="round"
          className="of-primaryBtnColor"
          onClick={handleAddressAdd}
        >
          <PlusCircleOutlined />
          &nbsp;{labelConfig.add}
        </Button>
      )}
      <Divider style={{ marginTop: 10, marginBottom: 30 }} />
      <Row>
        {addressDetails.map((item, index) => {
          return (
            <Col span={12} key={index} style={{ padding: "0px 8px" }}>
              <Spin spinning={isLoading} size="large">
                <CustomerAddressInfo
                  customerDetails={customerDetails}
                  addressData={item}
                  handleAddressEdit={handleAddressEdit}
                  isLoading={isLoading}
                  handleDisableOrEnable={handleDisableOrEnable}
                />
              </Spin>
            </Col>
          );
        })}
      </Row>
    </>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddressInfoTab);

function CustomerAddressInfo(props) {
  const {
    customerDetails,
    addressData,
    handleAddressEdit,
    handleDisableOrEnable,
  } = props;

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {addressData.addressType} INFO
          </Title>
        }
        key="1"
      >
        <Row
          style={{
            marginBottom: "8px",
          }}
        >
          <Button
            type="primary"
            shape="round"
            className="of-primaryBtnColor"
            style={{
              marginLeft: "auto",
            }}
            onClick={() => handleDisableOrEnable(addressData)}
          >
            &nbsp;
            {addressData.isActive === true
              ? labelConfig.disable
              : labelConfig.enable}
          </Button>
          {BOM.HasPermission("UPDATE_ADDRESS") && (
            <Button
              type="primary"
              shape="round"
              className="of-primaryBtnColor"
              style={{
                marginLeft: "5px",
              }}
              onClick={() => handleAddressEdit(addressData)}
            >
              <EditOutlined />
              &nbsp;{labelConfig.edit}
            </Button>
          )}
        </Row>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>Address ID</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>{addressData.addressId}</Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Address Line 1</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {addressData.addressLine1}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Address Line 2</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {addressData.addressLine2}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Address Line 3</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {addressData.addressLine3}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>City </Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}> {addressData.city}</Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>State / Province</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>{addressData.stateName}</Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Is Active?</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {addressData.isActive === true ? "True" : "False"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Longitude</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>{addressData.longitude}</Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Latitude</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>{addressData.latitude}</Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Country</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {addressData.countryName}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Created Date</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {BOM.FormatArrayDate(addressData.createdOn)}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>Updated Date</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {BOM.FormatArrayDate(addressData.updatedOn)}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>Postal Code</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>{addressData.postalCode}</Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}
